import React from 'react';
import Question from './Question';
import { CustomerType } from 'store/modules/Customers/types';

interface Props {
  customers: CustomerType[];
  isJointed: boolean;
  fields: any;
}

const Questions = ({ fields, customers, isJointed }: Props) => {
  return fields.map((field: any, index: number) => {
    const questionData = fields.get(index);

    return (
      <Question
        key={index}
        index={index}
        field={field}
        questionData={questionData}
        customers={customers}
        isJointed={isJointed}
      />
    );
  });
};

export default Questions;
